export default __webpack_public_path__ + "static/text-hero-main-7888656e6a7cd9b9a474f3bd9e6af6d3.png";